import React from "react";
import * as S from "./styles";
export function InfoBlock(_ref) {
  var e = _ref.image,
      t = _ref.title,
      a = _ref.content,
      n = _ref.size,
      c = _ref.className,
      r = _ref.numberTag,
      l = _ref.cta;
  var o = "object" == typeof e;
  return React.createElement(S.InfoBlock, {
    size: n,
    className: c
  }, React.createElement(S.ImageWrapper, {
    size: n
  }, React.createElement(S.ImageContainer, {
    size: n,
    isComponent: o
  }, o ? e : React.createElement(S.Image, {
    src: e,
    "aria-hidden": "true"
  })), r ? React.createElement(S.NumberTag, null, r) : null), React.createElement(S.ContentContainer, {
    size: n
  }, React.createElement(S.Title, {
    size: n
  }, t), React.createElement(S.Content, {
    size: n
  }, a), l ? React.createElement(S.CTA, {
    href: l.url
  }, l.text) : null));
}
export default InfoBlock;